// removed by extract-text-webpack-plugin
module.exports = {"ErrorTextWrapper":"AlertError-module__ErrorTextWrapper__3j6IB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/AlertError/AlertError.module.css
// module id = 1697
// module chunks = 29